<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.signaturePriority.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.signaturePriority.description') }}
    </p>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="signature-required"
        @change="update"
        data-vs-radio-button="signaturePriority"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.signaturePriority.option.label') }}</span>
      </zt-radio-button>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="signature-required"
        @change="update"
        data-vs-radio-button="signaturePriority"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.signaturePriority.option1.label') }}</span>
      </zt-radio-button>
    </div>

    <div class="w-full mt-16" v-if='withPriority'>
      <h2 class="custom-title custom-color-gray font-medium mb-4">
        {{ $t('message.abm.folders.settings.signaturePriority.question1') }}
      </h2>
      <p class="custom-legend text-zt-dark-300 mb-10">
        {{ $t('message.abm.folders.settings.signaturePriority.description1') }}
      </p>

      <div class="relative">
        <label
          class="top-label z-10 px-2 text-zt-xs bg-white absolute"
          :class="{
            'text-zt-dark-300': !errorText,
            'text-zt-danger': errorText,
          }"
        >
          {{ $t('message.abm.folders.settings.signaturePriority.select') }}
        </label>

        <MultiSelect
          label="name"
          track-by="id"
          class="border-zt-dark-300 rounded border"
          :class="{ 'border-danger' : errorText }"
          :placeholder="$t('message.abm.folders.settings.signaturePriority.select')"
          :select-label="$t('message.abm.folders.settings.signaturePriority.selectLabel')"
          :select-group-label="$t('message.abm.folders.settings.signaturePriority.selectGroupLabel')"
          :selected-label="$t('message.abm.folders.settings.signaturePriority.selectedLabel')"
          :deselect-label="$t('message.abm.folders.settings.signaturePriority.deselectedLabel')"
          :deselect-group-label="$t('message.abm.folders.settings.signaturePriority.deselectedGroupLabel')"
          :value="folderSelected"
          :options="lockEnabledList"
          :multiple="true"
          :internal-search="false"
          :searchable="true"
          :close-on-select="false"
          :clear-on-select="true"
          :preserve-search="false"
          :show-labels="false"
          :show-no-options="false"
          :loading="isLoading"
          @input="setFolderSelected"
        >
          <template
            slot="tag"
            slot-scope="{ option, remove }"
          >
            <div class="custom-chip inline-block max-w-full">
              <div class="main-bg flex rounded py-2 pl-3 pr-3 mb-2 mr-3 items-center">
                <div class="pr-2">
                  <p class="whitespace-no-wrap truncate">
                    {{ capitalize(option.name) }}
                  </p>
                </div>
                <button class="focus:outline-none" @click="remove(option)" data-vs-button="remove">
                  <zt-icon name="times" />
                </button>
              </div>
            </div>
          </template>
          <template slot="noResult">
            <span>{{ $t('message.abm.folders.settings.signaturePriority.noResult') }}</span>
          </template>
        </MultiSelect>
        <span class="text-zt-danger absolute text-base pt-1" v-show="errorText">
          {{ errorText }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import MultiSelect from 'vue-multiselect'
import Folders from '@/apiClient/Folders'
import { isEmpty } from 'lodash'
export default {
  name: 'SignaturePriority',
  components: {
    MultiSelect
  },
  inject: ['stateFolder', 'setParams', 'resetError'],
  data() {
    return {
      selected: 'false',
      lockEnabledList: [],
      isLoading: false,
      folderSelected: ''
    }
  },
  computed: {
    withPriority() {
      return (/^(true|1)$/i).test(this.selected) && !!this.selected
    },
    errorText() {
      if (this.stateFolder.error.code === '10028') {
        return this.stateFolder.error.message
      }
      return ''
    }
  },
  created() {
    this.folderApi = new Folders()
    this.selected = this.stateFolder.params.hasBlocking.toString()
    this.update()
  },
  methods: {
    setFolderSelected(e) {
      this.folderSelected = e
      this.resetError()
      this.setParams({
        blocking: this.folderSelected.map(item => item.id).toString()
      })
    },
    capitalize(word) {
      return word
        .toLowerCase()
        .replace(/\w/, first => first.toUpperCase())
    },
    async update() {
      this.folderSelected = ''
      this.isLoading = true
      this.setParams({
        hasBlocking: this.withPriority
      })
      if (this.withPriority) {
        if(this.stateFolder.params.id) {
          const folderId = this.stateFolder.params.id
          await this.getLockFolderEnabled(folderId)
          const folderSelected = !isEmpty(this.stateFolder.params.blocking)
            ? this.stateFolder.params.blocking.split(',')
            : []
          this.folderSelected = this.lockEnabledList.filter((item) => {
            return folderSelected.indexOf(item.id) > -1
          })
          this.isLoading = false
        } else {
          await this.getLockFolderEnabled()
          this.isLoading = false
        }
      } else {
        this.isLoading = false
        this.lockEnabledList = []
      }
    },
    async getLockFolderEnabled(params) {
      try {
        const {
          data: { data }
        } = await this.folderApi.getLockEnabledFolders(params)
        this.lockEnabledList = data
      } catch(e) {
        this.lockEnabledList = []
        this.isLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.top-label {
  font-size: 12px;
  line-height: 1;
  top: -7px;
  left: 1rem;
}
::v-deep {
  .zt-radiobutton {
    label {
      padding-top: 4px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
  .multiselect {
    box-sizing: border-box;
    border-color: #969696!important;
    border-radius: .375em!important;
  }
  .multiselect--above .multiselect__content-wrapper {
    bottom: 110%;
    border-bottom: 1px solid #969696;
  }
  .multiselect__content-wrapper {
    border-radius: 0.375em !important;
    border-color: #969696;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background-color: #c4c4c4;
  }
  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 0.625rem;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #888888;
  }
  .multiselect__spinner {
    right: 3px;
    width: 38px;
    height: 45px;
    &:before,
    &:after {
      border-color: #6200EE transparent transparent;
    }
  }
  .multiselect__tags {
    border: none;
    padding: 8px 38px 0 8px;
    border-radius: .375em!important;
  }
  .multiselect__select {
    padding-left: 16px;
  }
  .multiselect__option {
    padding-left: 2rem;
  }
  .multiselect__option--group {
    background: transparent;
    font-weight: bold;
    padding: 1rem;
  }
  .multiselect__option--selected,
  .multiselect__option--highlight {
    background-color: #e7e8ff!important;
    color: #707070;
    font-weight: normal;
  }
  .multiselect__select {
    top: 50%;
    margin-top: -19px;
    &:before {
      border-color: rgba(109, 109, 109, 1) transparent transparent;
    }
  }
  .multiselect__placeholder {
    margin-left: 2rem;
  }
  .multiselect__input {
    padding-left: 2rem!important;
    color: #2D2D2D;
  }

  .multiselect__option.multiselect__option--selected {
    display: none;
  }
}
.custom-chip {
  font-size: 14px;
  color: rgba(0, 0, 0, .87);
  .main-bg {
    background: rgba(137, 141, 255, .5);
  }
  button {
    width: 15px;
    height: 15px;
    color: rgba(137, 141, 255, .5);
    background: rgba(0, 0, 0, .6);
    font-weight: 600;
    font-size: 9px;
    color: #fff;
    border-radius: 50%;
  }
}
.border-danger {
  border-color: #F16B6C!important;
}
</style>
